var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../../elements/Basic");

var _Match = _interopRequireDefault(require("../../Match"));

var _i18n = _interopRequireDefault(require("../../../../i18n"));

var _MatchComponents = require("../../Match/MatchComponents");

var _PropsHelper = require("../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/ConferenceTicker/Header/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var ConferenceTickerHeader = function (_React$Component) {
  (0, _inherits2.default)(ConferenceTickerHeader, _React$Component);

  var _super = _createSuper(ConferenceTickerHeader);

  function ConferenceTickerHeader() {
    var _this;

    (0, _classCallCheck2.default)(this, ConferenceTickerHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderMatchComponent = function (match, index) {
      var _this$props = _this.props,
          matchComponent = _this$props.matchComponent,
          onMatchPress = _this$props.onMatchPress,
          trackBwin = _this$props.trackBwin,
          bettingProviderLogo = _this$props.bettingProviderLogo,
          createLivetickerHref = _this$props.createLivetickerHref;

      if (typeof matchComponent === 'function') {
        return matchComponent({
          match: match,
          index: index,
          onPress: onMatchPress,
          trackBwin: trackBwin,
          bettingProviderLogo: bettingProviderLogo,
          createLivetickerHref: createLivetickerHref
        });
      }

      return _react.default.createElement(_Match.default, {
        trackBwin: trackBwin,
        onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onMatchPress, match.id),
        match: match,
        bettingProviderLogo: bettingProviderLogo,
        pageId: match.id,
        key: match.id,
        href: (0, _PropsHelper.executeFunctionOrUndefined)(createLivetickerHref, (0, _get.default)(match, 'competition.id'), match.id),
        invertTeamAlignment: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49,
          columnNumber: 13
        }
      });
    };

    _this.renderTitle = function () {
      var _this$props2 = _this.props,
          hideHeadline = _this$props2.hideHeadline,
          matches = _this$props2.matches,
          titleComponent = _this$props2.titleComponent;

      if (typeof titleComponent === 'function') {
        return !hideHeadline ? titleComponent(matches) : null;
      }

      return !hideHeadline ? _react.default.createElement(_MatchComponents.CompetitionTitle, {
        match: matches[0],
        titleSuffix: ", " + (0, _i18n.default)('conference'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 13
        }
      }) : null;
    };

    return _this;
  }

  (0, _createClass2.default)(ConferenceTickerHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          matches = _this$props3.matches,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["matches"]);
      if ((0, _isEmpty.default)(matches)) return null;
      return _react.default.createElement(_Basic.Column, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82,
          columnNumber: 13
        }
      }, this.renderTitle(), _react.default.createElement(_Basic.Column, (0, _extends2.default)({}, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84,
          columnNumber: 17
        }
      }), matches.map(function (match, index) {
        return _this2.renderMatchComponent(match, index);
      })));
    }
  }]);
  return ConferenceTickerHeader;
}(_react.default.Component);

exports.default = ConferenceTickerHeader;
ConferenceTickerHeader.propTypes = {
  matches: _propTypes.default.instanceOf(Array).isRequired,
  onMatchPress: _propTypes.default.func,
  trackBwin: _propTypes.default.func,
  matchComponent: _propTypes.default.func,
  titleComponent: _propTypes.default.func,
  createLivetickerHref: _propTypes.default.func,
  hideHeadline: _propTypes.default.bool
};
ConferenceTickerHeader.defaultProps = {
  hideHeadline: false
};